import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { PanelCard } from '../ui/PanelCard';
import { listOpsProposals } from '../../lib/opsApi';
import { useCan } from '../../hooks/useCan';
import { isOpsEnabled } from '../../lib/keycloak';
import { fmtWhen } from '../../lib/opsFormat';
import type { OpsProposal } from '../../lib/types';

export function OpsPendingProposals() {
  const canView = useCan('ops', 'view');
  const opsEnabled = isOpsEnabled();
  const enabled = canView && opsEnabled;

  const query = useQuery({
    queryKey: ['ops-proposals', 'pending'],
    queryFn: () => listOpsProposals('pending'),
    enabled,
    refetchInterval: 30_000,
  });

  if (!enabled) return null;

  const proposals: OpsProposal[] = query.data ?? [];

  return (
    <div className="mb-3">
      <PanelCard
        title="Propostas pendentes"
        action={
          <Link
            to="/ops"
            className="text-[11px] font-medium text-accent hover:underline"
          >
            Ver e aprovar
          </Link>
        }
      >
        {query.isLoading ? (
          <div className="p-4 text-xs text-textMute">Carregando…</div>
        ) : query.isError ? (
          <div className="p-4 text-xs text-danger">
            Erro ao carregar propostas
          </div>
        ) : proposals.length === 0 ? (
          <div className="p-6 text-center text-xs text-textMute">
            Nenhuma proposta aguardando decisão
          </div>
        ) : (
          proposals.slice(0, 5).map((p, i) => (
            <Link
              key={p.id}
              to={`/ops/runs/${p.runId}`}
              className={
                'flex items-center gap-2.5 px-3.5 py-2 text-[11px] hover:bg-surfaceAlt' +
                (i > 0 ? ' border-t border-borderSoft' : '')
              }
            >
              <span className="min-w-0 flex-1 truncate font-mono text-text">
                {p.tool}
              </span>
              {p.tier && (
                <span className="flex-shrink-0 rounded bg-warnBg px-1.5 py-0.5 text-[9.5px] font-semibold text-warn">
                  {p.tier}
                </span>
              )}
              <span className="flex-shrink-0 font-mono text-[10px] text-textSoft">
                {fmtWhen(p.createdAt)}
              </span>
            </Link>
          ))
        )}
      </PanelCard>
    </div>
  );
}

export default OpsPendingProposals;
